var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.mode === 0
    ? _c(
        "div",
        { staticClass: "text-right my-2" },
        [
          _c(
            "b-button",
            {
              staticClass: "second-btn",
              on: {
                click: function ($event) {
                  _vm.modal = true
                },
              },
            },
            [_vm._v(_vm._s(_vm.formOpenerText))]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                "hide-footer": "",
                title: _vm.formTitle,
                size: "xl",
                "ok-title": _vm.okTitle,
                "cancel-title": _vm.cancelTitle,
                show: "",
                scrollable: "",
                centered: "",
                lazy: "",
              },
              on: {
                cancel: function ($event) {
                  _vm.modal = false
                },
              },
              model: {
                value: _vm.modal,
                callback: function ($$v) {
                  _vm.modal = $$v
                },
                expression: "modal",
              },
            },
            [
              _c(
                "search-request-form",
                {
                  attrs: {
                    mode: 0,
                    "help-text": _vm.formHelp,
                    "search-keyword": _vm.searchKeyword,
                    advancedSearchText: _vm.advancedSearchText,
                    "ok-title": _vm.okTitle,
                    "cancel-title": _vm.cancelTitle,
                  },
                  on: {
                    submit: function ($event) {
                      return _vm.closeModal()
                    },
                    cancel: function ($event) {
                      _vm.modal = false
                    },
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2 second-btn",
                      attrs: { slot: "cancelButton", type: "reset" },
                      on: {
                        click: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                      slot: "cancelButton",
                    },
                    [_vm._v(_vm._s(_vm.cancelTitle))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        [
          _c("div", {
            staticClass: "text-muted text-wrap",
            domProps: { innerHTML: _vm._s(_vm.searchText) },
          }),
          _vm._v(" "),
          _c("search-request-form", {
            attrs: {
              mode: 1,
              "search-keyword": _vm.searchKeyword,
              advancedSearchText: _vm.advancedSearchText,
              "ok-title": _vm.okTitle,
              "cancel-title": _vm.cancelTitle,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }